module.exports = __webpack_public_path__ + "img/seminar (68).9a6db8fe.jpg";